import D3Asset from '@/editor/assets/d3.asset'
import { omit as _omit } from 'lodash'

// import { DEFAULT_DURATION } from '@/etc/consts'

export default class CameraAsset extends D3Asset {
  constructor(uuid) {
    super(uuid)
    this._type = 'camera'
    this._props = _omit(this._props, [
      'scale.x', 'scale.y', 'scale.z', 'opacity'
    ])
    this._props['position.z'] = 100
    this._camera = null
  }

  initCamera(camera) {
    this._camera = camera
    if (!this._camera)
      return
    const pos = this._camera.position
    const rot = this._camera.rotation
    this.applyProps({
      'position.x': pos.x,
      'position.y': pos.y,
      'position.z': pos.z,
      'rotation.x': rot.x,
      'rotation.y': rot.y,
      'rotation.z': rot.z,
    })
  }

  get PROPS() {
    const p = super.PROPS
    return _omit(p, ['scale', 'opacity'])
  }

  get resizable() { return false }

  loadFromFile() {
    return new Promise(resolve => {
      this._asset.meta.name = 'Camera'
      this._asset.ready = true
      this.emit('ready')
      resolve()
    })
  }

  icon() {
    return ['fas', 'camera']
  }

  updateFrame(time, localTime, frame, zf, isPlay, propsUp) {
    this.dbg.log('updateFrame', time, localTime, frame)
    const props = typeof propsUp === 'undefined'
      ? super.updateFrame(time, localTime, frame)
      : propsUp
    this._camera.position.set(props['position.x'], props['position.y'], props['position.z'])
    this._camera.rotation.x = props['rotation.x']
    this._camera.rotation.y = props['rotation.y']
    this._camera.rotation.z = props['rotation.z']
    // frame.controller.position.set(props['position.x'], props['position.y'], props['position.z'])
    // frame.controller.rotation.x = props['rotation.x']
    // frame.controller.rotation.y = props['rotation.y']
    // frame.controller.rotation.z = props['rotation.z']
    return props
  }

}
